(function ($) {
  $(document).ready(function(){
    $('.vid-banner .field--name-field-media-video-file .field--item').append('<div class="vidplayicon"><img src="/themes/custom/hipster/images/icons/src/play-button.svg" alt="play-button"></div>');
    $('.vid-banner .field--name-field-media-video-file .field--item').append('<div class="vidpauseicon"><img src="/themes/custom/hipster/images/icons/src/pause.svg" alt="pause-button"></div>');

    $('.vid-banner video').addClass('hero-video');
    $('.vid-banner .field--name-field-media-video-file .field--item').addClass('videopause')

     // check for Internet Explorer
    if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1))
    { 
      $('.par-slider video').each(function() {
        $(this)[0].play();
      });
    }

    $(window).scroll(function() { 
      $('video').each(function() {
        if ($(this).visible(true)) {
          // $(this)[0].play();
        } 
        else {         
          if($(this).hasClass('hero-video')){
            $(this)[0].pause();
            $('.vidplayicon').show();
            $('.vidpauseicon').hide();
            $(this).closest('.field--item').addClass('videopause');
          }
        }
      })

    });  

    $('.vid-banner .field--name-field-media-video-file video').click(function(){
      if($(this).closest('.field--item').hasClass('videopause')) {
        $(this)[0].play();
        $('.vidpauseicon').show();
        $('.vidplayicon').hide();
        $(this).closest('.field--item').removeClass('videopause');
      } else {
        $(this)[0].pause();
        $('.vidplayicon').show();
        $('.vidpauseicon').hide();
        $(this).closest('.field--item').addClass('videopause');
      }
    });

    $('.vid-banner .field--name-field-media-video-file video, .vidplayicon, .vidpauseicon').mouseover(function(){
      if(!$(".vidplayicon").is(":visible")){
        $('.vidpauseicon').show();
      }
    });
    $('.vid-banner .field--name-field-media-video-file video, .vidplayicon, .vidpauseicon').mouseout(function(){
      $('.vidpauseicon').hide();
    });

    $('.vidplayicon, .vidpauseicon').click(function() {
      if(!$(".vidplayicon").is(":visible")){
        $('.vidpauseicon').show();
      }

      $('.vid-banner .field--name-field-media-video-file video').trigger('click');
    });

  });

})(jQuery);


